export default "__VITE_ASSET__aa15afa4__"